export const NUMBER_GENERATOR_INTERFACE_NAME = 'servint';
export const NUMBER_GENERATOR_INTERFACE_VERSION = '4.0';

export const SERVICE_INTERACTION_API = '/settings/service-interaction';
export const SERVICE_INTERACTION_NUMBER_GENERATOR_SEQUENCES_API = '/settings/service-interaction/numberGeneratorSequences/';

export const NUMBER_GENERATOR_OPTIONS_OFF = 'off';
export const NUMBER_GENERATOR_OPTIONS_ONEDITABLE = 'onEditable';
export const NUMBER_GENERATOR_OPTIONS_ONNOTEDITABLE = 'onNotEditable';

export const VENDOR_CODE_GENERATOR_OPTIONS = [
  { value: NUMBER_GENERATOR_OPTIONS_OFF },
  { value: NUMBER_GENERATOR_OPTIONS_ONEDITABLE },
  { value: NUMBER_GENERATOR_OPTIONS_ONNOTEDITABLE },
];

export const VENDOR_CODE_GENERATOR_CODE = 'organizations_vendorCode';
export const VENDOR_CODE_GENERATOR_SETTINGS_KEY = 'vendor-code-generator-setting';
